let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gZKQW"), load("7rEYM"), load("cyGuT"), load("jryQt")]).then(() => parcelRequire('73TCo'));